import { useCallback, useEffect, useRef, useState } from "react";
import { localStorageVars } from "../config";

const useWebSocket = (url) => {
  const [messages, setMessages] = useState([]);
  const [ws, setWs] = useState(null);
  const [wsOpen, setWsOpen] = useState(false);
  const [reconnect, setReconnect] = useState({
    reconnecting: false,
    reconnectCount: 0,
    reconnectInterval: 1000,
  });
  const reconnectTimerRef = useRef(null);
  const wsRef = useRef(null);

  const sendMessage = (message) => {
    if (wsOpen) {
      ws.send(JSON.stringify(message));
    }
  };
  const connect = useCallback((attempt = 0) => {
    const token = localStorage.getItem(localStorageVars.token);
    const connector = url.includes("?") ? "&" : "?";
    const wsUrl = token ? `${url}${connector}token=${encodeURIComponent(token)}` : url;
    const ws = new WebSocket(wsUrl);
    setWs(ws);
    wsRef.current = ws;

    ws.onmessage = (event) => {
      console.log(event.data);
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          ...JSON.parse(event.data).message,
          status: "received",
        },
      ]);
    };
    ws.onopen = () => {
      setWsOpen(true);
    };
    ws.onclose = (event) => {
      if (event.wasClean) {
        console.log("Connection closed cleanly");
      } else {
        console.log("Connection closed unexpectedly");
        const nextAttempt = attempt + 1;
        const nextDelay = Math.min(
          reconnect.reconnectInterval * Math.max(nextAttempt, 1),
          10000,
        );
        setReconnect((prevReconnect) => ({
          ...prevReconnect,
          reconnecting: true,
          reconnectCount: nextAttempt,
        }));
        reconnectTimerRef.current = setTimeout(() => {
          connect(nextAttempt);
        }, nextDelay);
      }
      setWsOpen(false);
      // implement reconnect using standard backoff algorithm
    };
  }, [reconnect.reconnectInterval, url]);

  useEffect(() => {
    connect();
    // const ws = new WebSocket(url);
    // setWs(ws);

    // ws.onmessage = (event) => {
    //   console.log(event.data);
    //   setMessages((prevMessages) => [
    //     ...prevMessages,
    //     {
    //       ...JSON.parse(event.data).message,
    //       status: "received",
    //     },
    //   ]);
    // };
    // ws.onopen = () => {
    //   setWsOpen(true);
    // };
    // ws.onclose = () => {
    //   setWsOpen(false);
    //   // implement reconnect using standard backoff algorithm

    // };

    // return () => {
    //   ws.close();
    // };
    return () => {
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [connect]);

  const removeMessage = (id) => {
    setMessages((prevMessages) =>
      prevMessages.filter((message) => message.id !== id),
    );
  };

  const clearMessages = (messagesIds) => {
    if (messagesIds.length) {
      setMessages((prevMessages) =>
        prevMessages.filter((message) => !messagesIds.includes(message.id)),
      );
    } else {
      setMessages([]);
    }
  };

  return { messages, ws, sendMessage, removeMessage, clearMessages, wsOpen };
};

export default useWebSocket;
